import i18n from 'services/base/i18n';

export default {
  // The label for the current download speed of the network
  downloadLabel: () => i18n.pgettext('Pages|Device Information', 'DOWNLOAD'),
  // The label for the current upload speed of the network
  uploadLabel: () => i18n.pgettext('Pages|Device Information', 'UPLOAD'),
  // The label for how many devices are connected right now
  devicesLabel: () => i18n.pgettext('Pages|Device Information', 'Devices'),
  connectedDevices: (value: number) => i18n.sprintf(
    // This tells the user how many devices are currently connected to the Pangolin.
    i18n.npgettext('Pages|Device Information', '%d Connected', '%d Connected', value),
    value,
  ),
  // With more than 99 devices on the network, we just display "99+ Connected"
  connectedDevicesOver99: () => i18n.pgettext('Pages|Device Information', '99+ Connected'),
  // The label for the current location of the user
  userLocationLabel: () => i18n.pgettext('Pages|Device Information', 'User Location'),
  // A link to the traffic history page
  trafficHistory: () => i18n.pgettext('Pages|Device Information', 'Traffic History'),
  // A link to the bandwidth prioritization page
  bandwidthPrioritization: () => i18n.pgettext('Pages|Device Information', 'Bandwidth Prioritization'),
  // A link to the parental controls page
  parentalControls: () => i18n.pgettext('Pages|Device Information', 'Parental Controls'),
  // A link to the vpn server page
  vpnServer: () => i18n.pgettext('Pages|Device Information', 'VPN Server'),
};
